import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '@common/modal/modal';

import BoonButterflyIcon from '@assets/svg/boon-butterfly.svg';

const VerifyPartnerSuccessModal: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Modal id="verify-partner-success">
            <div className="signup-success-container px-5 text-center text-black text-sm">
                <p className="font-bold">{t('base:verify-partner-success-header')}</p>
                <img width="50" className="inline-block py-2" src={BoonButterflyIcon} />
                <p className="pb-2">{t('base:verify-partner-success-message')}</p>
            </div>
        </Modal>
    );
};

export default VerifyPartnerSuccessModal;
